interface StarterTarget {
  setText: (text: string) => void;
  focus: () => void;
}

/** A starter only prepares the draft: the person reviews it and sends it themselves. */
export function applyCopilotStarter(target: StarterTarget, text: string): void {
  target.setText(text);
  target.focus();
}
